/**
 * What the Flexible Program page loads for every template the coach could
 * import (see ImportTemplateModal). Deliberately light: the picker fetches the
 * selected template's workouts on demand (flexible-import-template GET).
 *
 * Keep "programs.sessions.week": the cycle endpoint counts weeks from the
 * sessions (calculateNumberOfWeeks) and the page crashed without it (sc-47072).
 */
export const TEMPLATE_PROJECTION = {
  name: 1,
  type: 1,
  storeType: 1,
  "programs.numberOfWeeks": 1,
  "programs.isDeleted": 1,
  "programs.sessions.week": 1,
} as const;
